import * as React from 'react';
import { DataGrid } from '@material-ui/data-grid';

function InsiderTransactionsDataGrid({data} :any) {

  function truncateStr(str, n){
    return (str.length > n) ? str.substr(0, n-1) + '...' : str;
  };

  function tableRowClass(decisionColor) {
    if (decisionColor == 'Dispose') {
      return 'table-danger'
    } else {
      return 'table-success'
    }
  }

  const columns = [
    { field: 'id', hide: true},
    { field: 'date', headerName: 'Date', width: 100, renderHeader:(params) => ( <strong>Date</strong>)},
    { field: 'owner', headerName: 'Owner', width: 180, renderHeader:(params) => ( <strong>Owner</strong>)},
    { field: 'title', headerName: 'Title', width: 210, renderHeader:(params) => ( <strong>Title</strong>)},
    { field: 'type', headerName: 'Type',  width: 80, renderHeader:(params) => ( <strong>Type</strong>)},
    { field: 'transaction', headerName: 'Transaction', width: 200, renderHeader:(params) => ( <strong>Transaction</strong>)},
    { field: 'code', headerName: 'Code', width: 65, renderHeader:(params) => ( <strong>Code</strong>)},
    { field: 'shares', headerName: 'Shares', width: 150, renderHeader:(params) => ( <strong>Shares</strong>)},
    { field: 'value', headerName: 'Value', width: 150, renderHeader:(params) => ( <strong>Value</strong>)},
    { field: 'price', headerName: 'Price', width: 100, renderHeader:(params) => ( <strong>Price</strong>)},
    { field: 'remaining', headerName: 'Remaining', width: 100, renderHeader:(params) => ( <strong>Remaining</strong>)}
  ]

  function buildCompanyData(item) {
    return {
      id: item.id,
      date: item.transactionDate,
      owner: item.fullName,
      title: item.reportedTitle,
      type: item.transaction_type,
      transaction: item.transaction_code_in_words,
      code: item.transactionCode,
      shares: item.transaction_shares_in_words,
      value: item.transaction_value_in_words,
      price: item.tranPrice,
      remaining: item.post_shares_in_words
    }
  }

  const rows = data?.map(item => buildCompanyData(item));

  return (
    <div className="row">
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10]}
        autoHeight={true}
        autoPageSize={true}
        density={"compact"}
        disableColumnMenu
        getRowClassName={(params) =>
          (tableRowClass(params.getValue(params.id, 'type')))
        }
      />
    </div>
  );
}

export default InsiderTransactionsDataGrid;
